require('expose-loader?HomeComponents!../../src/app/home_components');
